module.exports = __webpack_public_path__ + "static/media/iconSearchWhite.a65fef5f.svg";